import * as Sentry from "@sentry/astro";

Sentry.init({
    dsn: "https://a61ff36eefa172308c063cdd27f0f321@o4511645794041856.ingest.us.sentry.io/4511673243926528",
    dataCollection: {
        // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#dataCollection
        // userInfo: false,
        // httpBodies: [],
    },

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    _experiments: { enableLogs: true },
    integrations: [
        // Sentry.browserTracingIntegration(), // there is a warning in the console:
        // `Multiple browserTracingIntegration instances are not supported.`
        Sentry.consoleLoggingIntegration({
            levels: ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'],
        }),
    ],

    // Define how likely traces are sampled. Adjust this value in production,
    // or use tracesSampler for greater control.
    tracesSampleRate: 1.0,
});